module.exports = __webpack_public_path__ + "img/hemiao.aafbc56b.aafbc56b.gif";